import { gql } from "@apollo/client";

export const GET_USUARIOS_RESPONSABLES_SIN_VALIDAR = gql`
    query allUsuariosResponsablesSinArea($idArea: Int!) {
        allUsuariosResponsablesSinArea(idArea: $idArea){
            idUsuario
            usuario
            nombre
            apellido
            email
        }
}`;